export default __webpack_public_path__ + "static/media/iphone.df9694c3.png";